import { compact } from 'lodash-es';
import { approvalMethodNoticePeriodModel, relationshipModel } from "../../../../../../models";
import { requestAccountantAccessModel } from "../../../../../../models/request-accountant-access";
export const getAdditionalTermsData = relationship => compact([{
  key: 'effectiveDate',
  title: 'Effective date of agreement',
  description: relationshipModel.formatEffectiveDate(relationship)
}, {
  key: 'paymentTerms',
  title: 'Payment terms',
  description: relationshipModel.paymentTermsText(relationship)
}, {
  key: 'amendments',
  title: 'Amendments',
  description: approvalMethodNoticePeriodModel.amendmentsDescription(relationship.amendmentsApprovalMethod)
}, approvalMethodNoticePeriodModel.isAutoApproval(relationship.invoicesApprovalMethod) && {
  key: 'outOfScopeCharges',
  title: 'Out of scope charges',
  description: approvalMethodNoticePeriodModel.invoicesDescription(relationship.invoicesApprovalMethod)
}, requestAccountantAccessModel.wasRequested(relationship.requestAccountantAccess) && {
  key: 'accountantAccess',
  title: 'Accountant Access',
  description: "Will allow the ".concat(relationship.vendor.name, " team to view your account information on Anchor, including invoices, agreements, and payments, as well as manage your payment methods.")
}, relationship.extraClause && {
  key: 'agreementNotes',
  title: 'Agreement notes',
  description: relationship.extraClause
}]);